import React, { Component } from "react";
import EmptyPanel from "./empty-panel";
import GroupDetails from "./group-details";
import GroupEdit from "./group-edit";
import GroupNew from "./group-new";
import ImagePanel from "./image-panel";

class GroupPanel extends Component {
  constructor() {
    super();
    this.state = {
      group: null,
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.group !== this.props.group) {
      this.setState({ group: this.props.group });
    }
  }
  onClickSubmit = (data) => {
    const { onSubmit } = this.props;
    onSubmit && onSubmit(data);
  };
  onClickEditGroup = () => {
    const { onChangeActiveTab } = this.props;
    onChangeActiveTab && onChangeActiveTab("edit");
  };
  onClickEditSubmit = (data) => {
    const { onEditSubmit } = this.props;
    onEditSubmit && onEditSubmit(data);
  };
  renderComponent = () => {
    const {
      activeTab,
      creatingError,
      editError,
      openSlidebox,
      setOpenSlidebox,
      onGroupRefresh,
    } = this.props;
    const { group } = this.state;
    switch (activeTab) {
      case "details":
        return (
          <GroupDetails
            group={group}
            onGroupRefresh={onGroupRefresh}
            onEdit={this.onClickEditGroup}
            changeActiveTab={this.props.onChangeActiveTab}
            footerNav={this.props.footerNav}
            setSelectedGroupItemIndex={this.props.setSelectedGroupItemIndex}
          />
        );
      case "image":
        return (
          <ImagePanel
            group={group}
            openSlidebox={openSlidebox}
            setOpenSlidebox={setOpenSlidebox}
            onGroupRefresh={onGroupRefresh}
            footerNav={this.props.footerNav}
          />
        );
      case "new":
        return (
          <GroupNew
            onSubmit={this.onClickSubmit}
            creatingError={creatingError}
            footerNav={this.props.footerNav}
            loading={this.props.loading}
            changeActiveTab={this.props.onChangeActiveTab}
            groups={this.props.groups}
            setLoading={this.props.setLoading}
          />
        );
      case "edit":
        return (
          <GroupEdit
            group={group}
            onSubmit={this.onClickEditSubmit}
            editError={editError}
            footerNav={this.props.footerNav}
            changeActiveTab={this.props.onChangeActiveTab}
          />
        );
      default:
        return <EmptyPanel />;
    }
  };

  render() {
    return (
      <div
        className={
          !this.props.activeTab || this.props.activeTab !== "image"
            ? "group-panel-component empty-panel"
            : "group-panel-component"
        }
      >
        {this.renderComponent()}
      </div>
    );
  }
}

export default GroupPanel;
